import classnames from 'classnames';

import { Div } from './HTMLElement';
import { RecommendedCartProductsProps } from './RecommendedCartProducts';
import { RecommendedCartProductTile } from './RecommendedCartProductTile';

export const RecommendedCartProductsA = ({ classNames, products }: RecommendedCartProductsProps) => {
  return (
    <Div className={classnames('recommended-cart-products', classNames)}>
      <Div className="header" paddingY={2}>
        <h6 className="title">Compra con</h6>
      </Div>
      {products.map((product) => (
        <Div className="content" key={product.id} uiClassName={{ bs5: 'bg-white border-bottom' }}>
          <RecommendedCartProductTile product={product} />
        </Div>
      ))}
    </Div>
  );
};
